import { Stack, Typography } from "@mui/material";
import SelectCountriesDropdown from "../../../../../../Components/Select/SelectCountries/SelectCountries";
import SelectAggregations from "../../../../../../Components/Select/SelectAggregations/SelectAggregations";

const SelectCountriesTab = () => {
  return (
    <Stack gap={5} maxWidth="720px" width="100%">
      <Stack gap={2}>
        <Typography variant="h5" color="#2D3648" fontWeight={500}>
          Choose target country
        </Typography>
        <SelectCountriesDropdown />
      </Stack>
      <Stack gap={2}>
        <Stack>
          <Typography variant="h5" color="#2D3648" fontWeight={500}>
            Choose the level of spatial aggregation
          </Typography>
          <Typography variant="subtitle1" color="#515167">
            Spatial aggregation is the aggregation of all data points for a
            group of resources
          </Typography>
        </Stack>
        <SelectAggregations />
      </Stack>
    </Stack>
  );
};

export default SelectCountriesTab;
